import * as React from 'react';

import {GlobalLoader} from './global-loader';

export const lazy = <T extends React.ComponentType<any>>(
  dynamicImport: () => Promise<{default: T}>,
  key?: React.Key,
) => (
  <React.Suspense fallback={<GlobalLoader />}>
    {React.createElement(React.lazy<React.ComponentType<{key?: React.Key}>>(dynamicImport), {
      key,
    })}
  </React.Suspense>
);
